import * as yup from 'yup';

export const schemaPassword = () => {
  return yup.object().shape({
    newPassword: yup.string().min(6, 'Mínimo 6 caracteres').required('Nova Senha é obrigatório'),
    checkPassword: yup.string().min(6, 'Mínimo 6 caracteres').oneOf([yup.ref('newPassword'), null], 'As senhas não correspondem')
  });
};

